import React, { FC } from 'react';
import { WarningOutlined } from '@duxton-web/icons';
import { ConfigProvider, Flex, theme, Typography } from '@duxton-web/ui';

import { GRABX_SLACK_CHANNEL } from '@/constants';

interface NotFoundProps {}

const NotFound: FC<NotFoundProps> = () => {
  return (
    <Flex
      vertical
      gap={24}
      align="center"
      justify="center"
      style={{
        height: '100%',
        backgroundColor: '#FFF',
      }}
    >
      <WarningOutlined
        style={{
          fontSize: 32,
          color: theme.getDesignToken().colorWarning,
        }}
      />
      <Flex vertical gap={4} align="center">
        <ConfigProvider
          theme={{
            components: {
              Typography: {
                titleMarginBottom: 0,
              },
            },
          }}
        >
          <Typography.Title level={3}>
            Opps! Looks like what you are looking for does not exists.
          </Typography.Title>
        </ConfigProvider>

        <Typography.Body
          level={3}
          style={{
            color: '#707070',
          }}
        >
          If you think this is an issue, please proceed to{' '}
          <Typography.Link href={GRABX_SLACK_CHANNEL} target="_blank">
            #grab-x
          </Typography.Link>{' '}
          and raise a ticket.
        </Typography.Body>
      </Flex>
    </Flex>
  );
};

export default NotFound;
